import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { LocationListComponent } from './list/location-list.component';
import { LocationCreateComponent } from './create/location-create.component';
import { LocationUpdateComponent } from './update/location-update.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: LocationListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'location.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add Location'
        },
        children: [
          {
            path: '',
            component: LocationCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'location.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update Location'
        },
        children: [
          {
            path: '',
            component: LocationUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'location.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocationRoutingModule {}
